/*
 * @file: index.js
 * @description: It Contain user related Action Creators.
 * @author: navreet
 */

import * as TYPE from '../constants'
import ApiClient from '../../api-client'
import { apiUrl } from '../../environment'
import { toastAction } from '../toast-actions'
import { push } from 'connected-react-router'
import Error from '../../components/error'

export const is_fetching = (status) => ({ type: TYPE.IS_FETCHING, status })
export const login_success = (data, email, checked, password, token) => ({
    type: TYPE.LOGIN_SUCCESS,
    data,
    email,
    checked,
    password,
    token,
})
export const setMobile = (data) => ({ type: TYPE.SET_MOBILE, data })
export const logout_user = () => ({ type: TYPE.LOG_OUT })
export const setForgotEmail = (data) => ({ type: TYPE.FORGOT_EMAIL, data })
export const user_list = (data, res) => ({ type: TYPE.USER_LIST, data, res })
export const setLoginButton = (data) => ({ type: TYPE.LOGIN_BUTTON, data })
export const errorUpdate = (data, message) => ({ type: TYPE.ERROR_STATUS, data, message })
export const lastLogin = (data) => ({ type: TYPE.LAST_LOGIN, data })

//**** Thunk Action Creators For Api ****//
/****** action creator for login ********/
export const login = (params, checked, callback) => {
    return (dispatch) => {
        dispatch(is_fetching(true))
        ApiClient.post(`${apiUrl}/userLoginAdmin`, params).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                dispatch(setLoginButton(false))
                if (checked) {
                    dispatch(
                        login_success(
                            response.data,
                            response.data.email,
                            checked,
                            params.password,
                            response.token,
                        ),
                    )
                } else {
                    dispatch(login_success(response.data, null, false, null, response.token))
                }

                callback(true, response.message,response)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))

                // toastAction(dispatch,false, response.message);
                callback(false, response.message,response)
            }
        })
    }
}

/****** action creator for forgotpassword ********/
export const forgotPassword = (params, callback) => {
    return (dispatch) => {
        dispatch(is_fetching(true))
        ApiClient.post(`${apiUrl}/forgotPasswordAdmin`, params).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                dispatch(setForgotEmail(params.email))
                callback(true)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                // toastAction(dispatch,false, response.message);
                callback(false)
            }
        })
    }
}

/****** action creator for otp verification  ********/
export const verifyOtp = (params, callback) => {
    return (dispatch) => {
        dispatch(is_fetching(true))
        ApiClient.post(`${apiUrl}/verifyOTPAdmin`, params).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                // toastAction(dispatch,false, response.message);
                callback(false)
            }
        })
    }
}

/****** action creator for resetPassword ********/
export const resetPassword = (params, callback) => {
    return (dispatch) => {
        dispatch(is_fetching(true))
        ApiClient.post(`${apiUrl}/changePasswordAdmin`, {
            email: params.email,
            password: params.password,
            passwordConfirmation: params.confirmpassword,
        }).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                // dispatch(setForgotEmail(null));
                // toastAction(true, response.message);
                callback(true)
            } else {
                dispatch(errorUpdate(true, response.message))
                dispatch(is_fetching(false))
                callback(false)
            }
        })
    }
}
/****** action get listing ********/
export const userListing = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.get(`${apiUrl}/userList`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                dispatch(user_list(response.data, response))
                // toastAction(true, response.message);
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(false)
            }
        })
    }
}

/****** action creator for delete User ********/

export const deleteUsers = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.delete(`${apiUrl}/deleteUsersAccountById`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}

/****** action creator for update User ********/
export const updateUserStatus = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.put(`${apiUrl}/adminUpdateUser`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                callback(false)
                dispatch(is_fetching(false))
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}

/****** action creator for logout ********/
export const logout = (token, callback) => {
    return (dispatch) => {
        dispatch(is_fetching(true));
        ApiClient.get(`${apiUrl}/logout`,null, token).then(response => {
         if (response.statusCode === 200) {
           dispatch(is_fetching(false));
        dispatch(logout_user())
        callback(true)
         } else {
           dispatch(is_fetching(false));
        //    toastAction(false, response.msg);
           callback(true);
         }
        });
    }
}
